import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'contracts_do_not_clearly_accurately_state_terms_conditions'

export const dataPointDefinition = {
  retracedId: 'contracts_do_not_clearly_accurately_state_terms_conditions',
  name: 'Contracts do not clearly and accurately state the terms and conditions of employment',
  description:
    'The intent of this option selection is to understand if contracts (for both local hires and foreign hires, if applicable) clearly and correctly state the terms and conditions of employment in languages and terms the worker can understand.',
  meta: {
    slcpMeta: {
      key: 'rh-emp-15',
      number: 'RH-EMP-11-2',
      masterType: 'Question',
      versionImported: '1.7.0',
    },
  },
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'rh-emp-15', version: '1.7.0', provider: 'slcp'}],
  sortingId: 34440,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
